var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"upload-box"},[_c('label',{class:{ 'upload-border': _vm.isImgShow, 'upload-label': true }},[_c('input',{ref:"file",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.getFileUrl}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }